export const BE_FLOW = {
	ORDER_CREATED: 1,
	DEPOSIT_PAID: 2,
	CHECK_CONFIRMED: 3,
	PURCHASE_CONFIRMED: 4,
	AGREEMENT_SIGNED: 5,
	TAIL_PAID: 6,
	INVOICE_FINISHED: 7,
	TRANSFORM_FINISHED: 8,
	ORDER_DELIVERY: 9,
	ORDER_CANCEL: 99
}

export const CE_FLOW = {
	WAIT_DEPOSIT: 1,
	DEPOSIT_PAID: 2,
	CHECK_CONFIRMED: 3,
	PURCHASE_CONFIRMED: 4,
	AGREEMENT_SIGNED: 5,
	TAIL_PAID_NOT_SEND: 6,
	TAIL_PAID_NOT_SEND_LOCAL: 6.1,

	TAIL_PAID_ON_ROAD: 7,
	TRANSFORM_FINISHED_NOT_BOOKING: 8,
	TRANSFORM_FINISHED_IN_BOOKING: 9,
	DELIVERY: 10,
	ORDER_CANCEL: 11,
	REFUND_FINISH: 12,
	REFUNDING: 13,

	ORDER_EXPIRED: 14
}

export function getCEStateByOrder(orderData) {
	const {
		order_status: { code }
	} = orderData

	switch (code) {
		case BE_FLOW.ORDER_CREATED:
			return CE_FLOW.WAIT_DEPOSIT
		case BE_FLOW.DEPOSIT_PAID:
			return CE_FLOW.DEPOSIT_PAID
		case BE_FLOW.CHECK_CONFIRMED:
			return CE_FLOW.CHECK_CONFIRMED

		case BE_FLOW.PURCHASE_CONFIRMED:
			return CE_FLOW.PURCHASE_CONFIRMED
		case BE_FLOW.AGREEMENT_SIGNED:
			return CE_FLOW.AGREEMENT_SIGNED

		case BE_FLOW.TAIL_PAID:
		case BE_FLOW.INVOICE_FINISHED:
			if (orderData.need_shipping + '' === '1') {
				return CE_FLOW.TAIL_PAID_NOT_SEND_LOCAL
			} else {
				if (orderData.delivery_status + '' === '2') {
					return CE_FLOW.TAIL_PAID_ON_ROAD
				} else {
					return CE_FLOW.TAIL_PAID_NOT_SEND
				}
			}
		case BE_FLOW.TRANSFORM_FINISHED:
			if (!orderData.delivery_car_status) {
				return CE_FLOW.TRANSFORM_FINISHED_NOT_BOOKING
			} else {
				return CE_FLOW.TRANSFORM_FINISHED_IN_BOOKING
			}
		case BE_FLOW.ORDER_DELIVERY:
			return CE_FLOW.DELIVERY
		case BE_FLOW.ORDER_CANCEL:
			if (orderData.cancel_reason_code === 6) {
				return CE_FLOW.ORDER_EXPIRED
			}

			if (
				orderData.pay_info.pay_back_amount &&
				orderData.pay_info.pay_back_amount === orderData.pay_info.pay_back_amount_refund
			) {
				return CE_FLOW.REFUND_FINISH
			}

			if (
				orderData.pay_info.pay_back_amount &&
				orderData.pay_info.pay_back_amount !== orderData.pay_info.pay_back_amount_refund
			) {
				return CE_FLOW.REFUNDING
			}

			return CE_FLOW.ORDER_CANCEL
	}
}
export const CE_FLOW_TITLE = {
	[CE_FLOW.WAIT_DEPOSIT]: '待支付定金',
	[CE_FLOW.DEPOSIT_PAID]: '定金已支付',
	[CE_FLOW.CHECK_CONFIRMED]: '验车已完成',
	[CE_FLOW.PURCHASE_CONFIRMED]: '购车方案已确认',
	[CE_FLOW.AGREEMENT_SIGNED]: '合同已签署',

	[CE_FLOW.TAIL_PAID_NOT_SEND]: '尾款已付清',
	[CE_FLOW.TAIL_PAID_NOT_SEND_LOCAL]: '尾款已付清',

	[CE_FLOW.TAIL_PAID_ON_ROAD]: '车辆运输中',
	[CE_FLOW.TRANSFORM_FINISHED_NOT_BOOKING]: '过户已完成',
	[CE_FLOW.TRANSFORM_FINISHED_IN_BOOKING]: '已预约提车',
	[CE_FLOW.DELIVERY]: '已提车',
	[CE_FLOW.ORDER_CANCEL]: '已取消',
	[CE_FLOW.ORDER_EXPIRED]: '已取消',
	[CE_FLOW.REFUNDING]: '退款中',
	[CE_FLOW.REFUND_FINISH]: '退款成功'
}
export const CE_FLOW_SUBTITLE = {
	[CE_FLOW.DEPOSIT_PAID]: '待验车',
	[CE_FLOW.CHECK_CONFIRMED]: '待确认购车方案',
	[CE_FLOW.PURCHASE_CONFIRMED]: '待签署合同',

	[CE_FLOW.AGREEMENT_SIGNED]: '待提车',

	[CE_FLOW.TAIL_PAID_NOT_SEND]: '待提车',
	[CE_FLOW.TAIL_PAID_NOT_SEND_LOCAL]: '待提车',

	[CE_FLOW.TAIL_PAID_ON_ROAD]: '待提车',
	[CE_FLOW.TRANSFORM_FINISHED_NOT_BOOKING]: '待提车',
	[CE_FLOW.TRANSFORM_FINISHED_IN_BOOKING]: p => `预约提车时间:${p}`
}

export const CE_FLOW_HELP = {
	[CE_FLOW.WAIT_DEPOSIT]: '“感谢选择蔚来官方二手车。请于指定时间内完成支付，超时订单会自动取消。”',
	[CE_FLOW.DEPOSIT_PAID]: '“感谢选择蔚来官方二手车。我们会尽快联系您预约验车。”',
	[CE_FLOW.CHECK_CONFIRMED]: '“您已完成验车，我们将根据您的需要为您确认最终购车方案。”',
	[CE_FLOW.PURCHASE_CONFIRMED]: '“我们已与您确认购车方案，将尽快联系您签署购车协议。”',
	[CE_FLOW.AGREEMENT_SIGNED]:
		'“已完成购车协议签署，将与你沟通尾款支付事宜。尾款支付完成后，将进行车辆物流运输。”',
	[CE_FLOW.TAIL_PAID_NOT_SEND]:
		'“您的车辆尾款已付清，正在安排物流运输。有任何物流进度消息，我们将第一时间通知您。”',
	[CE_FLOW.TAIL_PAID_NOT_SEND_LOCAL]: '“您的车辆尾款已付清，我们将协助您办理过户手续。”',
	[CE_FLOW.TAIL_PAID_ON_ROAD]:
		'“您的车辆正在物流运输途中，车辆运抵交付地后我们将协助您办理过户手续。”',
	[CE_FLOW.TRANSFORM_FINISHED_NOT_BOOKING]:
		'“您的车辆过户手续已完成。我们正在准备车辆交付事宜，交付准备工作完成后，我们将联系您预约提车。”',
	[CE_FLOW.TRANSFORM_FINISHED_IN_BOOKING]:
		'“您的车辆已完成所有交付准备工作，请携带好提车所需证件进行提车。”'
}
